import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  HOSPITAL_CONSULTANT_CREATE_REQUEST,
  HOSPITAL_CONSULTANT_CREATE_SUCCESS,
  HOSPITAL_CONSULTANT_CREATE_ERROR,
  HOSPITAL_CONSULTANT_UPDATE_REQUEST,
  HOSPITAL_CONSULTANT_UPDATE_SUCCESS,
  HOSPITAL_CONSULTANT_UPDATE_ERROR,
  HOSPITAL_CONSULTANT_DELETE_REQUEST,
  HOSPITAL_CONSULTANT_DELETE_SUCCESS,
  HOSPITAL_CONSULTANT_DELETE_ERROR,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

// CREATE
export const hospitalConsultantCreateRequest = () => ({
  type: HOSPITAL_CONSULTANT_CREATE_REQUEST,
});

export const hospitalConsultantCreateSuccess = (data) => ({
  type: HOSPITAL_CONSULTANT_CREATE_SUCCESS,
  data,
});

export const hospitalConsultantCreateError = (error) => ({
  type: HOSPITAL_CONSULTANT_CREATE_ERROR,
  error,
});

export const hospitalConsultantCreate = (data) => {
  return (dispatch) => {
    dispatch(hospitalConsultantCreateRequest());
    return requests
      .post(`${API_ROUTES.HOSPITAL_CONSULTANTS}`, data)
      .then((response) => {
        dispatch(hospitalConsultantCreateSuccess(response));
        return response;
      })
      .catch((error) => {
        dispatch(hospitalConsultantCreateError(error));
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// UPDATE
export const hospitalConsultantUpdateRequest = () => ({
  type: HOSPITAL_CONSULTANT_UPDATE_REQUEST,
});

export const hospitalConsultantUpdateSuccess = (data) => ({
  type: HOSPITAL_CONSULTANT_UPDATE_SUCCESS,
  data,
});

export const hospitalConsultantUpdateError = (error) => ({
  type: HOSPITAL_CONSULTANT_UPDATE_ERROR,
  error,
});

export const hospitalConsultantUpdate = (id, data) => {
  return (dispatch) => {
    dispatch(hospitalConsultantUpdateRequest());
    return requests
      .patch(`${API_ROUTES.HOSPITAL_CONSULTANTS}/${id}`, data)
      .then((response) => {
        dispatch(hospitalConsultantUpdateSuccess(response));
        return response;
      })
      .catch((error) => {
        dispatch(hospitalConsultantUpdateError(error));
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// DELETE
export const hospitalConsultantDeleteRequest = () => ({
  type: HOSPITAL_CONSULTANT_DELETE_REQUEST,
});

export const hospitalConsultantDeleteSuccess = (id) => ({
  type: HOSPITAL_CONSULTANT_DELETE_SUCCESS,
  id,
});

export const hospitalConsultantDeleteError = (error) => ({
  type: HOSPITAL_CONSULTANT_DELETE_ERROR,
  error,
});

export const hospitalConsultantDelete = (id) => {
  return (dispatch) => {
    dispatch(hospitalConsultantDeleteRequest());
    return requests
      .delete(`${API_ROUTES.HOSPITAL_CONSULTANTS}/${id}`)
      .then(() => {
        dispatch(hospitalConsultantDeleteSuccess(id));
        return id;
      })
      .catch((error) => {
        dispatch(hospitalConsultantDeleteError(error));
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
